// extracted by mini-css-extract-plugin
module.exports = {"UsageScenarios":"UsageScenarios_UsageScenarios__ZRahx"};